import { useMemo } from "react";
import { checkUserPermissionFunc } from "../components/common/CommonFunctions";

// Aligned with administrator.models.InternshipModule field names and the
// name= values in internship/urls.py. Unlike training, internship is NOT on
// the every-employee allow-list in the API, so these keys are the real gate.
export const useInternshipPermissions = () => {
    return useMemo(() => {
        const programs = checkUserPermissionFunc("internship", "internship_programs", "SubMenu");
        const enrolments = checkUserPermissionFunc("internship", "internship_enrolments", "SubMenu");
        const mine = checkUserPermissionFunc("internship", "my_internship", "SubMenu");
        const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false")
            || JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
        const allow = (p) => isAdmin || !!p?.permission;
        return {
            canManagePrograms: allow(programs),
            canManageEnrolments: allow(enrolments),
            canViewMyInternship: allow(mine),
        };
    }, []);
};

export default useInternshipPermissions;
